<template>
    <section
        id="user-form"
        class="max-width-600-tablet-desktop"
    >
        <el-form
            ref="formRef"
            :model="form"
            label-width="100px"
            :rules="rules"
            @submit.prevent="saveSubmit"
        >
            <el-form-item
                label="First Name"
                prop="first_name"
                :error="errors.get('first_name')"
            >
                <el-input
                    v-model="form.first_name"
                    suffix-icon="edit-pen"
                    @change="errors.clear('first_name')"
                />
            </el-form-item>
            <el-form-item
                label="Last Name"
                prop="last_name"
                :error="errors.get('last_name')"
            >
                <el-input
                    v-model="form.last_name"
                    suffix-icon="edit-pen"
                    @change="errors.clear('last_name')"
                />
            </el-form-item>
            <el-form-item
                label="Email"
                prop="email"
                :error="errors.get('email')"
            >
                <el-input
                    v-model="form.email"
                    suffix-icon="message"
                    autocomplete="new-email"
                    @change="errors.clear('email')"
                />
            </el-form-item>
            <el-form-item
                v-if="!form._id"
                label="Password"
                prop="password"
                :error="errors.get('password')"
                required
            >
                <el-input
                    v-model="form.password"
                    type="password"
                    show-password
                    autocomplete="new-password"
                    @change="errors.clear('password')"
                />
            </el-form-item>
        </el-form>
        <div>
            <el-button
                @click="cancel"
            >
                Cancel
            </el-button>
            <el-button
                :loading="formLoading"
                type="success"
                @click="saveSubmit"
            >
                Save
            </el-button>
        </div>
    </section>
</template>

<script setup>
import {onMounted, ref, watch} from 'vue'
import { ElMessage } from 'element-plus'
import {Errors} from '~/includes/Errors'
import dashUserApi from '../dashUserApi'

const emit = defineEmits()

const props = defineProps({
    initialForm: {
        type: Object,
        default: {}
    },
})

const errors = new Errors()
const formLoading = ref(false)
const form = ref({
    first_name: '',
    last_name: '',
    email: '',
    role: '',
})
const rules = {
    first_name: [
        { required: true, message: 'Name is required' },
    ],
    last_name: [
        { required: true, message: 'Name is required' },
    ],
    email: [
        { required:true, message: 'Please enter your email', trigger: 'blur' },
        { type: 'email', message: 'Invalid email', trigger: 'blur' }
    ],
}

onMounted(() => form.value = Object.assign({}, props.initialForm))

watch(
    () => props.initialForm,
    val => form.value = Object.assign({}, val),
    { deep: true }
)

const formRef = ref()

function saveSubmit() {
    formRef.value.validate((valid) => {
        if (valid) {
            formLoading.value = true
            errors.clear()
            let action = form.value._id ? dashUserApi.update : dashUserApi.create

            action(form.value).then((response) => {
                ElMessage.success( 'Saved successfully')
                emit('saved')
            }).catch(error => {
                if (error.response.data.errors) errors.record(error.response.data.errors)
            }).finally(() => formLoading.value = false)
        }
    })
}

function cancel() {
    clearForm()
    emit('cancel')
}

function clearForm() {
    errors.clear()
    if (formRef.value) formRef.value.resetFields()
}
</script>
